import React, { createContext, useContext, useEffect, useState } from "react";
import theme from "../services/themeServices";
import AuthContext from "./AuthContext";
import { useLocation } from "react-router-dom";
import { adminPath, teachersubadminPath } from "../services/defaultSettings";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => theme.getLanguage());
    const location = useLocation();
    const [isAdminPath, setIsAdminPath] = useState(false);
    useEffect(() => {
        if (
            location.pathname.includes(adminPath) ||
            location.pathname.includes(teachersubadminPath)
        ) {
            setLanguage("ar");
            theme.setLanguage("ar");
            document.body.style.direction = "rtl";
            document.body.style.textAlign = "right";
            document.body.style.fontFamily = "var(--font-family)";
            setIsAdminPath(true);
        } else {
            setIsAdminPath(false);
        }
    }, [location.pathname]);
    const switchLanguage = (lang) => {
        setLanguage(lang);
        theme.setLanguage(lang);
    };

    useEffect(() => {
        theme.setLanguage(language);
        const uploadTexts = {
            ar: "رفع",
            en: "Upload",
            de: "Hochladen",
        };
        document.querySelectorAll(".file-upload-wrapper").forEach((wrapper) => {
            wrapper.setAttribute("data-upload-text", uploadTexts[language] || "رفع");
        });
        // const computedText = getComputedStyle(document.documentElement).getPropertyValue(
        //     "--upload-text"
        // );
    }, [language]);
    useEffect(() => {
        if (!isAdminPath) {
            document.body.style.direction = language === "ar" ? "rtl" : "ltr";
            document.body.style.textAlign = language === "ar" ? "right" : "left";
            document.body.style.fontFamily =
                language !== "ar" ? "Arial, sans-serif" : "var(--font-family)";
        }
    }, [isAdminPath]);
    return (
        <LanguageContext.Provider value={{ language, switchLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
